import type { GridConfig } from "./scene-config";

interface GridPlaneProps {
  grid: GridConfig;
  className?: string;
}

/**
 * Dot grid rendered via CSS radial-gradient for zero canvas overhead.
 * Intro animation: dots fade/rise in via CSS keyframes.
 */
const GridPlane = ({ grid, className }: GridPlaneProps) => {
  return (
    <div
      className={className}
      aria-hidden="true"
      style={{
        backgroundImage: `radial-gradient(circle, ${grid.color} ${grid.dotRadius}px, transparent ${grid.dotRadius}px)`,
        backgroundSize: `${grid.spacing}px ${grid.spacing}px`,
        backgroundRepeat: "repeat",
        // Radial fade via mask
        maskImage: "radial-gradient(ellipse at center, black 50%, transparent 90%)",
        WebkitMaskImage: "radial-gradient(ellipse at center, black 50%, transparent 90%)",
        animation: "gridIntro 1.3s cubic-bezier(0.22, 0.61, 0.36, 1) forwards",
      }}
    />
  );
};

export default GridPlane;
